import { isCssColor, isDark } from '~/vue/color'

export default {
  props: {
    color: String
  },
  computed: {
    contrasting () {
      return this.isDark ? 'light' : 'dark'
    },
    isThemeColor: vm => !isCssColor(vm.color),
    isDark () {
      if (typeof this.$attrs.dark !== 'undefined') {
        return true
      }
      if (typeof this.$attrs.light !== 'undefined') {
        return false
      }
      return isDark(this.color)
    }
  }
}
